import {Component} from 'react';

class ResizableComponent<P = any, S extends { windowWidth: number } = any> extends Component<P, S> {

    constructor(props: P) {
        super(props);

        // @ts-ignore
        this.state = {
            windowWidth: window.innerWidth
        };
    }

    updateDimensions = () => {
        this.setState({ windowWidth: window.innerWidth});
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

}

export default ResizableComponent;